import { defineStore } from 'pinia';
import { toRaw } from 'vue';
import { reorderEventActions } from '../logic/logicGraph.js';
import { logicDomain } from '../logic/logicDomain.js';
import { graphStoreOptions } from './graphStoreOptions.js';

/**
 * Editor state for the event/action node graph, and the only place that
 * mutates `page.logic` on behalf of the user. Every mutation goes through
 * history as a LogicGraphCommand. The generic part (selection, placement,
 * connect, delete, …) is shared with the other graph domains; see
 * graphStoreOptions. The graph shows in Logic mode (`canvasModeStore`).
 */
export const useLogicStore = defineStore('logic', graphStoreOptions(logicDomain, {
    actions: {
        reorderEventActions(page, eventNodeId, wireIds) {
            page = toRaw(page);
            this.commit(page, reorderEventActions(page.logic, eventNodeId, wireIds), 'Reorder actions');
        },
    },
}));
